
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M220 120c0-55.135-44.821-100-99.972-100C64.877 20 20 64.865 20 120s44.877 100 100.028 100C175.179 219.944 220 175.135 220 120zm-95.738-91.93c23.652 1.072 45.724 11.117 62.207 28.273 16.483 17.212 25.628 39.786 25.628 63.601 0 50.733-41.264 91.986-92.012 91.986s-92.013-41.253-92.013-91.986c-.113-23.759 8.976-46.332 25.515-63.544 16.427-17.213 38.555-27.258 62.208-28.33h.225V170l-47.135-47.573c-1.524-1.58-4.064-1.58-5.645 0-.79.733-1.185 1.749-1.185 2.821 0 1.073.395 2.032 1.129 2.822l53.965 54.402c.395.395.847.677 1.299.903a3.737 3.737 0 001.524.338c.508 0 1.072-.113 1.524-.338.508-.226.903-.508 1.298-.847v-.056l53.966-54.402c.734-.734 1.129-1.749 1.129-2.822 0-1.072-.395-2.088-1.186-2.821-.733-.734-1.75-1.185-2.822-1.129a4.018 4.018 0 00-2.823 1.185l-47.135 47.573V28.07h.339z","fill-rule":"nonzero"}})])
          )
        }
      }
    